import { Box, Frame, Text } from '@timelyapp/react';
import classNames from 'classnames';
import React from 'react';
import type { Avatar } from 'types/user';
import styles from './column.module.scss';
import { COLUMN_SIZE_MEDIUM } from './constants';
import HeaderWithMenu from './HeaderWithMenu';
import type { DatatableCellRenderer, DatatableColumnGetter } from './types';

export const getUserColumn: DatatableColumnGetter<{ name: string; avatar: Avatar }> = (
  id: string
) => ({
  id,
  header: props => (
    <HeaderWithMenu
      {...props}
      label="User"
      sortLabelType="string"
      filterTriggerSelector='[data-testid="user-filter-dropdown"]'
    />
  ),
  minSize: COLUMN_SIZE_MEDIUM,
  enableResizing: true,
  enableSorting: true,
  meta: {
    numeric: false,
    label: 'User',
    mandatory: true,
    getValue: (user: { name: string }) => `${user.name}`,
  },
  cell: UserCell,
});

export const UserCell: DatatableCellRenderer<{ name: string; avatar: Avatar }> = ({ getValue }) => {
  const { name, avatar } = getValue();

  return (
    <Box.Row gap="medium">
      <Frame.Avatar
        src={avatar.medium_retina}
        alt={name}
        shape="circle"
        size="xsmall"
        className={classNames(styles.avatar, 'fs-mask')}
      />
      <Text size="small" title={name} className="fs-mask">
        {name}
      </Text>
    </Box.Row>
  );
};
